import { z } from "zod";

import { ERROR_TYPE } from "@/utils";
import { TokenPurpose } from "@/enum";
import { PASSWORD_REGEX } from "@/constants";

const { PASSWORD_GUIDELINES, REQUIRED } = ERROR_TYPE;

export const SetPasswordSchema = z.object({
	password: z
		.string()
		.min(1, { message: REQUIRED })
		.regex(PASSWORD_REGEX, PASSWORD_GUIDELINES)
		.trim(),
	confirmPassword: z.string().min(1, { message: REQUIRED }).trim(),
});

export const SetPasswordRequestSchema = z.object({
	password: z.string().min(8),

	token: z.string().min(1, { message: REQUIRED }),
	purpose: z.nativeEnum(TokenPurpose),
});

export type SetPasswordType = z.infer<typeof SetPasswordSchema>;
export type SetPasswordBody = z.infer<typeof SetPasswordRequestSchema>;
